export const candidates = [
  {
    name: "Olivia Rhye",
    email: "@olivia",
    status: "Open to work",
    location: "New York",
    title: "Software Engineer",
    previous: "Graphic Designer at XXS Studios",
    education: "University of Boston - Degree in Visual and Graphic Design",
    summary: "Helping businesses create and deliver an incredible customer experience. I possess excellent communication, problem solving, and benefit me in the workplace.",
    experience: "Helping businesses create and deliver an incredible customer experience. I possess excellent communication, problem solving, and benefit me in the workplace.",
    company: "Tech Corp",
    bestMatch: 85,
    skillsScore: 80,
    avatar: "",
  },
  {
    name: "Phoenix Baker",
    email: "@phoenix",
    status: "Inactive",
    location: "San Francisco",
    title: "Product Manager",
    previous: "Project Coordinator at Innovate Inc",
    education: "Stanford University - MBA",
    summary: "Experienced in managing cross-functional teams to deliver products successfully.",
    experience: "Led multiple successful product launches, coordinating with development, design, and marketing teams.",
    company: "Innovate Inc",
    bestMatch: 92,
    skillsScore: 90,
    avatar: "",
  },
  {
    name: "Lana Steiner",
    email: "@lana",
    status: "Active",
    location: "Chicago",
    title: "UX Designer",
    previous: "Junior Designer at Creative Labs",
    education: "Art Institute of Chicago - BFA in Graphic Design",
    summary: "Passionate UX designer focused on improving user experiences.",
    experience: "Designed multiple web and mobile applications with a focus on usability.",
    company: "Creative Labs",
    bestMatch: 78,
    skillsScore: 75,
    avatar: "",
  },
  {
    name: "Demi Wilkinson",
    email: "@demi",
    status: "Active",
    location: "Seattle",
    title: "DevOps Engineer",
    previous: "Systems Administrator at CloudWorks",
    education: "University of Washington - BS in Computer Science",
    summary: "Specialist in cloud infrastructure and CI/CD pipelines.",
    experience: "Implemented automated deployment workflows and monitoring solutions.",
    company: "CloudWorks",
    bestMatch: 88,
    skillsScore: 85,
    avatar: "",
  },
  {
    name: "Candice Wu",
    email: "@candice",
    status: "Inactive",
    location: "Boston",
    title: "QA Analyst",
    previous: "Tester at QualityPlus",
    education: "Boston University - BS in Software Engineering",
    summary: "Experienced QA analyst ensuring product quality and performance.",
    experience: "Performed automated and manual testing on multiple software products.",
    company: "QualityPlus",
    bestMatch: 81,
    skillsScore: 78,
    avatar: "",
  },
  {
    name: "Natali Craig",
    email: "@natali",
    status: "Active",
    location: "Austin",
    title: "Frontend Developer",
    previous: "Web Developer at Webify",
    education: "University of Texas - BS in Computer Science",
    summary: "Frontend developer with focus on React and modern JS frameworks.",
    experience: "Built responsive web applications with modern front-end tech.",
    company: "Webify",
    bestMatch: 90,
    skillsScore: 87,
    avatar: "",
  },
  {
    name: "Orlando Diggs",
    email: "@orlando",
    status: "Active",
    location: "Denver",
    title: "Project Manager",
    previous: "Assistant PM at BuildRight",
    education: "University of Denver - MBA",
    summary: "Project manager ensuring successful project delivery.",
    experience: "Managed timelines, resources, and project stakeholders effectively.",
    company: "BuildRight",
    bestMatch: 86,
    skillsScore: 82,
    avatar: "",
  },
  {
    name: "Andi Lane",
    email: "@andi",
    status: "Inactive",
    location: "Miami",
    title: "Data Scientist",
    previous: "Data Analyst at DataWorks",
    education: "University of Miami - MS in Data Science",
    summary: "Data scientist with focus on predictive modeling and analytics.",
    experience: "Developed machine learning models for business insights.",
    company: "DataWorks",
    bestMatch: 79,
    skillsScore: 76,
    avatar: "",
  },
  {
    name: "Kate Morrison",
    email: "@kate",
    status: "Active",
    location: "Los Angeles",
    title: "Backend Developer",
    previous: "Software Engineer at TechCorp",
    education: "UCLA - BS in Computer Science",
    summary: "Backend developer specialized in Node.js and database systems.",
    experience: "Built scalable APIs and backend services for web applications.",
    company: "TechCorp",
    bestMatch: 84,
    skillsScore: 80,
    avatar: "",
  },
];